import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {

}

// mutations
const mutations = {
    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.status == 'ACTIVE'){
                    updatestatus = 'INACTIVE'
                }
                else if(list.status == 'INACTIVE'){
                    updatestatus = 'ACTIVE'
                }
            }
        })

        const updateRef = db.collection('Mail').doc(payload);
        updateRef.update({ status:updatestatus })
    },

    alltaskcomplete:(state,payload)=>{
        var updatestatus = "";
        if(payload) {
            updatestatus = 'complete'    
        } else {
            updatestatus = 'incomplete'
        }
        state.todo.forEach(function (list) {
            const updateRef = db.collection('Mail').doc(list.id);
            updateRef.update({ status:updatestatus })
        })
    },

    tododelete:(state,payload)=>{
        db.collection('Mail').doc(payload).delete()
    },

    addtodo:(state, payload)=>
    {
        db.collection('Mail').add({ 
            
            
            senderUid: payload.email_senderUid,
            senderName: payload.email_senderName,
            receiverUid: payload.email_receiverUid,

            item:
            {
                id : parseInt(payload.email_itemId),
                count : parseInt(payload.email_itemCount)
            },
            deadline : payload.email_deadline,
            sendPush : payload.email_sendPush,
            
            title : payload.email_title,
            message : payload.email_message,           
            status : 'ACTIVE',
            created: new Date()
        })
    },

    retrieveTodos(state,todos){
        state.todo = todos
    }

};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('Mail').get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                //tempTodos.push(doc.data());
                //tempTodos.push({ id:doc.id, title:doc.data().title, delete:doc.data().delete, status:doc.data().status, created:doc.data().created });
                
                tempTodos.push({ 
                    id:doc.id, 
                    senderUid:doc.data().senderUid, 
                    senderName:doc.data().senderName, 
                    receiverUid:doc.data().receiverUid, 
                    item:doc.data().item,                    
                    deadline:moment(String(doc.data().deadline.toDate())).format('YYYY-MM-DD hh:mm'),
                    sendPush:doc.data().sendPush,
                    title:doc.data().title, 
                    message:doc.data().message,   
                    status:doc.data().status,                     
                    created:moment(String(doc.data().created.toDate())).format('YYYY-MM-DD hh:mm'), 
                    checked:doc.data().checked
                    
                });
                
            })

            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })

            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    alltaskcomplete:(context,payload) => {
        context.commit('alltaskcomplete',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    addtodo:(context, payload) => {
        context.commit('addtodo', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}